import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;



interface Option {id: number; name: string;}
interface Year extends Option{}
interface Quarter extends Option{}
interface HalfYear extends Option{}
interface Month extends Option{}
interface MonthType extends Option{}
interface PeriodTimeFilter {idElement?: string, year?: number; quarter?: string; month?: number, monthType?: number};


export class transactionTimePeriod_template extends vnTemplate {


    private quarterOptions: Array<Quarter>= [
        {id: 5, name: 'H1'},
        {id: 6, name: 'H2'},
        {id: 1, name: 'Q1'},
        {id: 2, name: 'Q2'},
        {id: 3, name: 'Q3'},
        {id: 4, name: 'Q4'}
    ];


    private halfYearOptions: Array<Quarter>= [
        {id: 5, name: 'H1'},
        {id: 6, name: 'H2'}
    ];

    private monthOptions: Array<Month> = [
        {id: 1, name: "January"},
        {id: 2, name: "February"},
        {id: 3, name: "March"},
        {id: 4, name: "April"},
        {id: 5, name: "May"},
        {id: 6, name: "June"},
        {id: 7, name: "July"},
        {id: 8, name: "August"},
        {id: 9, name: "September"},
        {id: 10, name: "October"},
        {id: 11, name: "November"},
        {id: 12, name: "December"}
    ];

    private monthTypeOptions: Array<MonthType> = [
        {id: 1, name: "Full"},
        {id: 2, name: "First half"},
        {id: 3, name: "Second half"}
    ];

    protected getTemplateHtml(): string {

        return `
                    <div class="form-group">
                        <hr>
                    </div>                 
                    <div class="form-group row">
                        <label for="year" class="form-label">Year</label>
                        <select id="year" style="width:100%;" data-bind="options: yearOptions, value: selectedYear, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true, event: {change: onYearChange}"></select>
                    </div>      
                    <div class="form-group row" data-bind="visible: showSubFilters()">
                        <label for="quarter" class="form-label">Half/Quarter</label>
                        <div class="multi">
                            <select id="quarter" data-bind="options: quarterOptions, value: selectedQuarter, optionsCaption: 'Select', optionsText: 'name', optionsValue: 'id', valueAllowUnset: true, event: {change: onQuarterChange}"></select>
                            <span class="form-text">OR</span>
                            <label for="month" class="form-label">Month</label>
                            <select id="month" data-bind="options: monthOptions, value: selectedMonth, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true, event: {change: onMonthChange}"></select>
                            <select id="monthType" data-bind="options: monthTypeOptions, value: selectedMonthType, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true, event: {change: onMonthTypeChange}"></select>
                        </div>
                    </div>
                    <div class="form-group">
                        <hr>
                    </div>         
                
            `;
    }

    public initData() {

        this.setYearOptions(this.buildYearOptions());
        this.setSelectedYear(new Date().getFullYear());
        this.setQuarterOptions(this.buildQuarterOptions());
        this.setMonthOptions(this.buildMonthsOptions());
        this.setMonthTypeOptions(this.buildMonthTypesOptions());
    }

    protected getTemplateName(): string {
        return "transactionTimePeriod_template";
    }

    protected getMainElementClasses(): Array<string> {
        return [""];
    }

    protected buildViewModel(): any {

        let self = this;
        return {
            yearOptions: ko.observableArray([]),
            quarterOptions: ko.observableArray([]),
            monthOptions: ko.observableArray([]),
            monthTypeOptions: ko.observableArray([]),
            selectedYear: ko.observable(null),
            selectedQuarter: ko.observable(null),
            selectedMonth: ko.observable(null),
            selectedMonthType: ko.observable(null),
            yearsBack: ko.observable(3),
            yearsAhead: ko.observable(10),
            showSubFilters: ko.observable(true),
            isDynamic: ko.observable(false),
            onYearChange:   (data, event) => {
                self.onYearChange();
            },
            onQuarterChange:  (data, event) => {
                self.onQuarterChange();
            },
            onMonthChange:  (data, event) => {
                self.onMonthChange();
            },
            onMonthTypeChange: (data, event) => {
                self.onMonthTypeChange();
            }
        };
    }


    private buildYearOptions(): Array<Year> {

        let currentYear = new Date().getFullYear();
        let yearsBack = this.getTemplateViewModel().yearsBack();
        let yearsAhead = this.getTemplateViewModel().yearsAhead();
        let startingYear = currentYear - yearsBack;
        let endingYear = currentYear;
        if (!this.isDynamic()) {

            endingYear = currentYear + yearsAhead;
        }

        let yearOptions = [];
        while(startingYear <= endingYear) {
            yearOptions.push({id: startingYear, name: startingYear});

            startingYear++;
        }

        return yearOptions;
    }

    private buildQuarterOptions(): Array<Quarter> {

        if (this.isDynamic()) {

            let today = new Date();
            let currentYear = today.getFullYear();
            let selectYear = this.getSelectedYear();
            let selectQuarter = this.getSelectedQuarter();

            if (selectYear < currentYear) {
                return this.quarterOptions;
            }

            let currentMonth = today.getUTCMonth() + 1;
            let lastQuarter = Math.ceil(currentMonth / 3);

            if (selectQuarter > lastQuarter) {
                this.setSelectedQuarter(null);
            }

            let lastHalf = Math.ceil(currentMonth / 6);
            let selectableQuarters =  this.halfYearOptions.slice(0, lastHalf);

            this.quarterOptions.forEach((qo) => { if (qo.id <= lastQuarter) selectableQuarters.push(qo); });


            return selectableQuarters;
        }

        return this.quarterOptions
    }

    private buildMonthsOptions(): Array<Month> {

        if (this.isDynamic()) {

            let today = new Date();
            let currentYear = today.getFullYear();
            let selectYear = this.getSelectedYear();
            let selectMonth = this.getSelectedMonth();

            if (selectYear < currentYear) {
                return this.monthOptions;
            }

            let currentMonth = today.getUTCMonth() + 1;
            if (selectMonth > currentMonth) {
                this.setSelectedMonth(null);
            }

            return this.monthOptions.filter((m) => m.id <= currentMonth);
        }

        return this.monthOptions
    }


    private buildMonthTypesOptions(): Array<MonthType> {

        let today = new Date();
        let currentDay = today.getUTCDate();
        let currentYear = today.getFullYear();
        let currentMonth = today.getUTCMonth() + 1;

        let selectYear = this.getSelectedYear();
        let selectMonth = this.getSelectedMonth();
        let selectMonthType = this.getSelectedMonthType();

        let changeMonthTypeOptions = ((selectYear == currentYear) && (selectMonth == currentMonth) && (currentDay < 16));

        if (changeMonthTypeOptions) {

            if (selectMonthType == 3) {
                this.setSelectedMonthType(1);
            }
            return this.monthTypeOptions.filter((mt) => mt.id != 3);
        }

        return this.monthTypeOptions;
    }


    public onYearChange(): void {

        let selectedYear = this.getTemplateViewModel().selectedYear();

        if(selectedYear == undefined) {
            this.setSelectedQuarter(null);
            this.setSelectedMonth(null);
            this.setSelectedMonthType(null);
            this.hideSubFilters();
        } else {

            this.setQuarterOptions(this.buildQuarterOptions());
            this.setMonthOptions(this.buildMonthsOptions());
            this.setMonthTypeOptions(this.buildMonthTypesOptions());
            this.showSubFilters();
        }
    }

    public onQuarterChange(): void {
        this.setSelectedMonth(null);
        this.setSelectedMonthType(null);
        this.enableSplitButton();

    }

    public onMonthChange(): void {

        let selectedMonth = this.getSelectedMonth();
        if(selectedMonth != undefined) {

            this.setMonthTypeOptions(this.buildMonthTypesOptions());
            let selectedMonthType = this.getSelectedMonthType();
            if (selectedMonthType == null) {

                this.setSelectedMonthType(1);
            }
        } else {

            this.setSelectedMonthType(null);
        }

        this.setSelectedQuarter(null);
        this.enableSplitButton();
    }

    private hideSubFilters(): void {
        this.getTemplateViewModel().showSubFilters(false);
    }

    private showSubFilters(): void {
        this.getTemplateViewModel().showSubFilters(true);
    }

    private enableSplitButton(): void {

        let selectedMonth = this.getSelectedMonth();
        let selectedQuarter = this.getSelectedQuarter();
        if(selectedMonth != undefined || selectedQuarter != undefined) {

            this.caller.enableSplitButtonCall(true);
        } else {
            this.caller.enableSplitButtonCall(false);

        }
    }

    public onMonthTypeChange(): void {

        this.setSelectedQuarter(null);
        this.enableSplitButton();
    }

    public setYearOptions(yearOptions: Array<Year>): void {

        this.getTemplateViewModel().yearOptions(yearOptions);

    }
    public setSelectedYear(selectedYear): void {

        this.getTemplateViewModel().selectedYear(selectedYear);

    }
    public setQuarterOptions(quarterOptions: Array<Quarter>): void {

        this.getTemplateViewModel().quarterOptions(quarterOptions);

    }
    public setSelectedQuarter(selectedQuarter): void {

        this.getTemplateViewModel().selectedQuarter(selectedQuarter);

    }
    public setMonthOptions(monthOptions: Array<Month>): void {

        this.getTemplateViewModel().monthOptions(monthOptions);

    }
    public setSelectedMonth(selectedMonth): void {

        this.getTemplateViewModel().selectedMonth(selectedMonth);

    }
    public setMonthTypeOptions(monthTypeOptions: Array<Option>): void {

        this.getTemplateViewModel().monthTypeOptions(monthTypeOptions);

    }

    public setSelectedMonthType(selectedMonthType): void {

        this.getTemplateViewModel().selectedMonthType(selectedMonthType);
    }

    public getYearOptions(): Array<Year> {

        return this.getTemplateViewModel().yearOptions();
    }

    public getSelectedYear() {

        return this.getTemplateViewModel().selectedYear();
    }

    public getQuarterOptions(): Array<Quarter>{

        return this.getTemplateViewModel().quarterOptions();
    }

    public getSelectedQuarter() {

        return this.getTemplateViewModel().selectedQuarter();
    }

    public getMonthOptions(): Array<Month> {

        return this.getTemplateViewModel().monthOptions();
    }

    public getSelectedMonth() {

        return this.getTemplateViewModel().selectedMonth();
    }
    public getMonthTypeOptions(): Array<MonthType> {

        return this.getTemplateViewModel().monthTypeOptions();
    }

    public getSelectedMonthType() {

        return this.getTemplateViewModel().selectedMonthType();
    }

    public setYearsBack(yearsBack: number): void {
        this.getTemplateViewModel().yearsBack(yearsBack);
    }

    public getYearsBack(): void {
        this.getTemplateViewModel().yearsBack();
    }

    public setYearsAhead(yearsAhead: number): void {
        this.getTemplateViewModel().yearsAhead(yearsAhead);
    }

    public getYearsAhead(): void {
        this.getTemplateViewModel().yearsAhead();
    }

    public setAsDynamic(isDynamic: boolean): void {

        this.getTemplateViewModel().isDynamic(isDynamic);
    }

    public isDynamic(): boolean {

        return this.getTemplateViewModel().isDynamic();
    }

    public getFilters(): PeriodTimeFilter {

        return {
            year: this.getSelectedYear(),
            quarter: this.getSelectedQuarter(),
            month: this.getSelectedMonth(),
            monthType: this.getSelectedMonthType()
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/transactionsTimePeriod_template.ts